import { render, staticRenderFns } from "./RoleSelector.vue?vue&type=template&id=59be0079&scoped=true"
import script from "./RoleSelector.vue?vue&type=script&lang=ts"
export * from "./RoleSelector.vue?vue&type=script&lang=ts"
import style0 from "./RoleSelector.vue?vue&type=style&index=0&id=59be0079&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59be0079",
  null
  
)

export default component.exports